import React from 'react';
import Gallery from '../Gallery';
import './Dance.css';
import Footer from '../Footer';

function Dance() {
    return (
        <div>
             <h1>Gallery</h1>
            
						<Gallery />
                        <Footer />
        </div>
    )
}

export default Dance;
